
import React, {Component} from 'react';
import { Tabs, Tab, HelpBlock, Button, Form, FormControl, FormGroup, InputGroup, ControlLabel, Row, Col, Checkbox, Popover, Tooltip, OverlayTrigger, Modal } from 'react-bootstrap';
import { Box } from 'reactjs-admin-lte';
import FontAwesome from 'react-fontawesome';
import Select from 'react-select';
import DatePicker from '../../component/element/DatePicker'
import StockStore from '../../stores/StockStore'
import './Stock.css';

class StockProductSerialManageModal extends React.Component {

  constructor(props) {
    super(props)
    this.state = {loading:false,sameDate:false,data:[],input:'',check_color:'',check_text:'',new_serial_id:''}
  }

  componentWillReceiveProps(newProps){
    if(newProps.itemnum!==undefined&&newProps.itemnum!=='' && newProps.itemnum!==this.props.itemnum){
      let that = this
      //this.setState({loading:true})
      // StockStore.loadStockProductSerial(newProps.stockType,newProps.itemnum,function(result){

      //   that.setState({loading:false,data:result.data})
      // },function(){
      //   that.setState({loading:false,data:[]})
      // })
    }
  }

  onDateChange(index,key,date) {
    let {data} = this.state
    data[index][key] = date
    this.setState({data:data})
  }

  onSameDateChange(e,e2){

    let {data,sameDate} = this.state
    if(data.length>1 && !sameDate){
      let import_date = data[0].import_date
      data = data.map((item,index)=>{
        item.import_date = import_date
        return item
      })
    }
    console.log('onSame',e,e2)
    this.setState({data:data,sameDate:!sameDate})
  }

  renderTable() {
    let {unit} = this.props
    let {sameDate} = this.state
    return(
      <table className='table table-responsive table-hover table-bordered-solid'>
        <thead>        
          <th className='text-center' style={{width:'50px'}}>ลำดับ</th>          
          <th className='text-center' style={{width:'150px'}}>ซีเรียล</th>
          <th className='text-center' style={{width:'150px'}}>รหัสสี</th>
          <th className='text-center' style={{width:'80px'}}>ปริมาณ<br/>(บนฉลาก)</th>
          <th className='text-center' style={{width:'80px'}}>ปริมาณ<br/>(ชั่งได้)</th>                    
          <th className='text-center' style={{width:'80px'}}>ต้นทุนต่อ{unit!==''?unit:'หน่วย'}</th>                   
          <th className='text-center' style={{width:'80px'}}>ชั้นวาง</th>                    
          <th className='text-center' style={{width:'80px'}}>วันที่รับของ<br/>
          <Checkbox
              style={{display:'inline-block'}}
              checkboxClass="icheckbox_square-blue"
              increaseArea="20%"
              label='เหมือนลำดับ 1'
              checked={sameDate}
              onChange={this.onSameDateChange.bind(this)}
            />เหมือนลำดับ 1
          </th>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
      </table>
    )
  }

  renderRowData() {
    let {data} = this.state
    if (data===undefined||data.length===0) {
      return(
        <tr><td colSpan={9}>ไม่พบข้อมูล</td></tr>
      )
    } else {
      return(
        data.map((item,index) => {
          return(
            <tr key={index} style={{backgroundColor:item.bg}}>
              <td className='text-center'>{index+1}</td>
              <td className='text-center'>
                <FormControl                  
                  value={item.serial_no}
                  onChange={this.onDataTextChange.bind(this,index,'serial_no')}
                >
                </FormControl>
              </td>
              <td className='text-center'>
                <FormControl                  
                  value={item.colorcode}
                  onChange={this.onDataTextChange.bind(this,index,'colorcode')}
                >
                </FormControl>
              </td>
              <td className='text-center'>
                <FormControl
                className='text-center'
                  value={item.init_quantity}
                  onChange={this.onDataTextChange.bind(this,index,'init_quantity')}
                >
                </FormControl>
              </td>
              <td className='text-center'>
                <FormControl
                className='text-center'
                  value={item.quantity}
                  onChange={this.onDataTextChange.bind(this,index,'quantity')}
                >
                </FormControl>
              </td>
              <td className='text-center'>
                <FormControl
                className='text-center'
                  value={item.cost}
                  onChange={this.onDataTextChange.bind(this,index,'cost')}
                >
                </FormControl>
              </td>
              
              <td className='text-center'>
                <FormControl
                className='text-center'
                  value={item.location}
                  onChange={this.onDataTextChange.bind(this,index,'location')}
                >
                </FormControl>
              </td>
              <td className='text-center'>               
                <DatePicker                  
                  value={item.import_date}
                  onChange={this.onDateChange.bind(this,index,'import_date')}
                  showIcon={true}
                  showFooter={true}
                  buddhistEra={true}
                  style={{ display: 'inline-block', minWidth: '160px' }}
                />
              </td>
              
            </tr>
          )
        })
      )
    } 
  }

  onDataTextChange(index,key,e) {
    let {data} = this.state
    data[index][key] = e.target.value
    this.setState({data:data})
  }

  onTextChange(e) {
    let {input} = this.state
    this.setState({input:e.target.value})
  }

  onKeyPress(e) {
    let {input,data,check_color,check_text} = this.state
    let checkFind = false
    if (e.charCode===13) {
      data.forEach(function(item,index) {
        if(item.serial_no===e.target.value) {
          data[index]['bg'] = 'rgba(0, 166, 90, 0.67)'
          check_color = 'rgba(0, 166, 90, 0.67)'
          check_text = 'หมายเลขซีเรียล '+e.target.value+' ตรวจสอบถูกต้อง'
          checkFind = true
        }
      })

      if(!checkFind) {
        check_color = 'rgb(221, 75, 57)'
        check_text = 'ไม่พบหมายเลขซีเรียล '+e.target.value
      } 
      this.setState({input:''}) 
    }
    this.setState({data:data,check_color:check_color,check_text:check_text})
  }

  runNumber(number, length) {
    let str = '' + number;
    while (str.length < length) {
        str = '0' + str;
    }
    return str;
  }

  onGenSerialClick(quantity,productcode,e) { 
    let {data} = this.state
    let {stockType,itemnum,last_serial_id} = this.props
    let that = this
    let new_last = last_serial_id
    StockStore.generateProductcode(stockType, itemnum,'','', function (result) {
      let productcode = result.productcode
      
      let newData = new Array(quantity).fill('').map((item,index)=>{
        new_last = last_serial_id*1+index+1
        return {
          seq:'',
          serial_no: productcode+'/'+that.runNumber(new_last, 4),   
          colorcode:'',       
          init_quantity: '',
          quantity: '',
          cost: '',                
          location: '',
          import_date: '',
          bg: '', 
        }
      })
      data= data.concat(newData)
      that.setState({data:data,new_serial_id:new_last})
    })
      
    
  }

  

  onSaveClick(){
    let {data,new_serial_id} = this.state
    let that = this
    this.setState({loading:true})
    StockStore.saveStockProductSerial(this.props.stockType,this.props.itemnum,{'itemlist':data,new_serial_id:new_serial_id},function(result){

      that.setState({loading:false,data:result.data.itemlist})
    },function(){
      that.setState({loading:false})
    })
  }

  renderTextAddRow() {
    let {input} = this.state
    return(
      <Row>
        <Col md={2}>
          <FormGroup>
            <ControlLabel style={{color:this.state.check_color}}>ตรวจสอบหมายเลขซีเรียล</ControlLabel>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <FormControl 
              value={input}
              onChange={this.onTextChange.bind(this)}
              onKeyPress={this.onKeyPress.bind(this)}
            >
            </FormControl>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <ControlLabel>
              <p style={{color:this.state.check_color}}>{this.state.check_text}</p>
            </ControlLabel>
          </FormGroup>
        </Col>
      </Row>
    )
  }

  onModalClose(e) {
    let {loading,data,check_color,check_text,input} = this.state
    this.setState({data:[],check_color:'',check_text:'',input:''})
    this.props.onHide()
  }

  render(){
    let {loading,data} = this.state
    let {description,unit,quantity,productcode} = this.props
    let fillQuantity = quantity*1 - data.length

    return (
      <Modal bsSize="large" show={this.props.onShow} onHide={this.onModalClose.bind(this)} dialogClassName="midwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>
            {description+' '+quantity+' '+unit}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>  
          <Box loading={loading} border={false}>        
            {this.renderTextAddRow()}
            {this.renderTable()}  
          </Box>        
        </Modal.Body>
        <Modal.Footer>
          <Button 
            className="btn-warning" 
            onClick={this.onGenSerialClick.bind(this,fillQuantity,productcode)}
            disabled={fillQuantity<=0}
          >
            <FontAwesome name='barcode' /> สร้างซีเรียล ({(fillQuantity)}) รายการ
          </Button>
          <Button className="btn-primary" onClick={this.onSaveClick.bind(this)}>
            <FontAwesome name='save' /> บันทึก
          </Button>
          <Button className="btn-default" onClick={this.onModalClose.bind(this)}>
            <FontAwesome name='remove' /> ยกเลิก
          </Button>            
        </Modal.Footer>
      </Modal>  
    )
  }
}


StockProductSerialManageModal.defaultProps = {
  last_serial_id:0
}

export default StockProductSerialManageModal;





// WEBPACK FOOTER //
// ./src/view/stock/StockProductSerialManageModal.js